<template>
    <div class="hiq-calendar__events">
        <div v-if="Object.keys(dates).length > 0">
            <div v-for="(events, date) in dates" :key="date">
                <h2>{{date}}</h2>
                <ul>
                    <event-item v-for="event in events" :key="event.id" :event="event"></event-item>
                </ul>
            </div>
        </div>
        <div v-else>
            <p>{{translations.noHits}}</p>
        </div>
    </div>
</template>
<script>
import Vue from 'vue'
import EventItem from './EventItem.vue';
export default Vue.extend({
    name: 'events',
    computed: {
        dates() {
            return this.$store.getters.dates;
        },
        translations() {
            return this.$store.state.translations;
        }
    },
    components: {
        EventItem
    }
})
</script>